var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3516 4.5C15.3516 5.01666 15.2105 5.48333 14.9283 5.9C14.646 6.31666 14.2891 6.61666 13.8574 6.8V21C13.8574 21.2833 13.7618 21.521 13.5705 21.713C13.3793 21.905 13.1429 22.0007 12.8613 22C12.579 22 12.3423 21.904 12.151 21.712C11.9598 21.52 11.8645 21.2827 11.8651 21V6.8C11.4335 6.61666 11.0765 6.31666 10.7943 5.9C10.512 5.48333 10.3709 5.01666 10.3709 4.5C10.3709 3.8 10.6116 3.20833 11.0931 2.725C11.5746 2.24166 12.164 2 12.8613 2C13.5586 2 14.148 2.24166 14.6294 2.725C15.1109 3.20833 15.3516 3.8 15.3516 4.5Z",
    fill: "#009FE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon);
export default __webpack_public_path__ + "static/media/line-icon.66093f8ab0a5fd88df26c5e42ec74546.svg";
export { ForwardRef as ReactComponent };